<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">
      <!-- Título -->
      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-badge display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              POLITICAS DE LA EMPRESA
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              DOUMENTOS LIBRES PARA CONSULTAR
            </p>
          </div>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-12 col-md-6 col-lg-3 d-flex" v-for="(politica) in politicasArray" :key="politica.id">

          <div class="card card-cuadrada h-100 shadow-sm border-2 p-4 rounded-4 w-100">

            <!-- HEADER (ICONO GRANDE A LA DERECHA + PDF PEQUEÑO A LA IZQUIERDA) -->
            <div class="d-flex justify-content-between align-items-center">
              <i class="bi bi-file-pdf text-danger display-6"></i>
              <div class="d-flex gap-2 align-items-center">

                <button class="btn btn-success border border-1"
                  :onclick="`window.open('${politica.rutaReglamento}', '_blank')`">
                  <i class="bi bi-download -down"></i>
                </button>
              </div>
            </div>

            <h5 class="mt-4 mb-2 card-title">
              {{ politica.nombreArchivo }}
            </h5>
          
          </div>
        </div>

        <div v-if="politicasArray.length === 0" class="text-center text-muted py-4">
          No hay políticas registradas.
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "CopiasPoliticas",

  data() {
    return {
      politicasArray: [],

    };
  },

  mounted() { },

  created() {
    this.getPoliticas();
    this.cambiarEstadoNavbar();
  },

  methods: {
    getPoliticas() {
      this.axios
        .get(
          `Contrato/ObtenerPoliticasXtrabajador/${localStorage.getItem(
            "idTrabajdor"
          )}`
        )
        .then((r) => {
          console.log(r.data);
          this.politicasArray = r.data;
        });
    },
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: black;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 1rem;
}
</style>